import {Fragment, useContext } from "react";

import LoginContext from '../../../../../store/login-context';
import classes from './Skip.module.scss';

declare function Translate(key: string): string;
declare var _siteSettings: any;

const Skip = () => {

    const ctx = useContext(LoginContext);

    const onSkipWizardClick = () => {
        ctx.displayRegForm(true); 
    };

    const onSkipWizardPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            onSkipWizardClick();
        }
    };

    const onMobileSkipWizardClick = () => {
        if(ctx.PreRegUser.length > 0){
            window.location.href = _siteSettings.signupLink + 
                                        "&userid=" + ctx.PreRegUser[0] +
                                        "&usermail=" + ctx.PreRegUser[1] + 
                                        "&userphone=" + ctx.PreRegUser[2] 
        }  
        else{
            window.location.href = _siteSettings.signupLink;
        }   
    };

    return(
        <Fragment>
            <div className={classes.skip_desktop}>
                <div className='preRegTextSmall'>{Translate('N_General_SignUp_Process')}</div>
                <div className='preRegLinkSmall'>
                    <a id='skipWizard' 
                        className='preRegLinkSmall' 
                        onClick={onSkipWizardClick}
                        onKeyPress={onSkipWizardPress}
                        tabIndex={0}               
                    >
                        {Translate('N_General_SignUp_Skip')}
                    </a>                                        
                </div>
            </div >
            <div className={classes.skip_mobile}>
                <div className='preRegTextSmall'>{Translate('N_General_SignUp_Process')}</div>
                <div className='preRegLinkSmall'>
                    <a id='skipWizard' 
                        className='preRegLinkSmall' 
                        onClick={onMobileSkipWizardClick}
                        tabIndex={0}               
                    >
                        {Translate('N_General_SignUp_Skip')}
                    </a>                                        
                </div>
            </div >
        </Fragment>
    );
};
export default Skip;